module.exports = __webpack_public_path__ + "img/play_button.8aecf6b2.png";